import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import RepairTabs, { type RepairTab } from '../components/RepairTabs';
import { fetchPageContent, type PageSection } from '../../../utils/pageContentStorage';

const TABS: RepairTab[] = [
  {
    key: 'screen',
    label: '螢幕維修',
    image: 'https://storage.readdy-site.link/project_files/a6fca87a-8436-4bd7-9e14-084f599afe41/8beaf0d4-a873-44b8-ae07-52edc3cd2623_IMG_7243.jpeg?v=824aa7cff0ae7f94835eebcd85cfbc7e',
    objectPosition: 'center',
    priceFrom: 'NT$1,800 起',
    time: '1–2 小時',
    warranty: '3 個月',
    features: [
      { point: '使用 OLED 原廠規格面板', detail: '色彩還原精準，觸控靈敏度維持原廠水準，無色差問題。' },
      { point: '更換後進行顯示校正', detail: '確保亮度、色溫正確，排除觸控漂移與邊緣失靈。' },
      { point: '可選原廠或副廠優質屏', detail: '依預算提供最適合的解決方案，更換前清楚說明差異。' },
    ],
  },
  {
    key: 'battery',
    label: '電池更換',
    image: 'https://storage.readdy-site.link/project_files/a6fca87a-8436-4bd7-9e14-084f599afe41/29305d69-0f29-48b9-99a2-5e728e1ab034_-1.jpg?v=926916a60aeae256c1d71a1dfd5b5d2c',
    objectPosition: 'center',
    priceFrom: 'NT$750 起',
    time: '30分–2小時',
    warranty: '3 個月',
    features: [
      { point: '高循環壽命電池', detail: '使用符合原廠容量規格的電芯，維持電量表現。' },
      { point: '更換後執行電量校正', detail: '確保電量顯示準確，解決電量顯示不正確問題。' },
      { point: '當場完工取回', detail: '多數機型 30 分鐘內完成，不影響您的行程。' },
    ],
  },
  {
    key: 'camera',
    label: '鏡頭維修',
    image: 'https://storage.readdy-site.link/project_files/a6fca87a-8436-4bd7-9e14-084f599afe41/d6833630-e105-4dec-8308-97982731d18f_IMG_8513.jpeg?v=6c2ba3249eb3d33c2e38dc507b368414',
    objectPosition: 'center',
    priceFrom: 'NT$800 起',
    time: '1–2 小時',
    warranty: '3 個月',
    features: [
      { point: '前後鏡頭均可處理', detail: '後主鏡頭、長焦鏡頭、前置 FaceTime 鏡頭全系列更換。' },
      { point: '更換後拍攝測試', detail: '確認對焦清晰、OIS 防手震正常、4K 拍攝無問題。' },
      { point: '不影響 Face ID', detail: '前鏡頭維修流程嚴謹，不破壞 Face ID 模組排線。' },
    ],
  },
  {
    key: 'faceid',
    label: 'Face ID 修復',
    image: 'https://storage.readdy-site.link/project_files/a6fca87a-8436-4bd7-9e14-084f599afe41/3e9c123e-6fe5-45de-a6aa-0ff5851b224d_SaveClip.App_461306584_17991190613686948_1866214839062137285_n.jpg?v=f1f7fceddcb80c141911a9cf29e81e04',
    objectPosition: 'center',
    priceFrom: 'NT$2,000 起',
    time: '2–3 小時',
    warranty: '3 個月',
    features: [
      { point: 'Face ID 模組精密修復', detail: '點陣投影器、紅外線鏡頭損壞均可評估修復。' },
      { point: '修復後完整功能測試', detail: '確認 Face ID 識別率正常，解鎖、支付功能全數驗證。' },
      { point: '無法修復不收費', detail: '評估後如無法修復，免收診斷費。' },
    ],
  },
  {
    key: 'storage',
    label: '容量升級',
    image: 'https://static.readdy.ai/image/15419bedb578ec59343dd2ae27ec91d5/b47c0e1779c0e10d7a59a9dbd1be8133.jpeg',
    objectPosition: 'center',
    priceFrom: '依機型報價',
    time: '當天可好',
    warranty: '3 個月',
    features: [
      { point: '儲存空間不足？直接升級', detail: '部分機型可評估儲存晶片升級，解決容量不足問題。' },
      { point: '升級前完整備份協助', detail: '升級前協助資料備份，確保資料完整不遺失。' },
      { point: '升級後系統功能測試', detail: '確認 iOS 正常運作、App 資料完整後才交件。' },
    ],
  },
  {
    key: 'board',
    label: '主板 / 進水搶救',
    image: 'https://storage.readdy-site.link/project_files/a6fca87a-8436-4bd7-9e14-084f599afe41/3a89005a-4b3c-4f54-a401-f558d41bb7b4_SnapInsta.to_623805789_18046470284686948_5897225264130193861_n.jpg?v=c1554d9a73b2a26db9d2c7378d507c77',
    objectPosition: 'center',
    priceFrom: 'NT$3,000 起',
    time: '1–5 工作天',
    warranty: '3 個月',
    features: [
      { point: '主板層級精密焊接', detail: '短路、斷腳、IC 損壞均可處理，配備顯微焊接設備。' },
      { point: '進水腐蝕清洗', detail: '超音波清洗 + 腐蝕處理，提升救機成功率。' },
      { point: '修復率業界前段', detail: '承接同業代工、高難度案件，技術成熟值得信賴。' },
    ],
  },
];

export default function IphoneServicePage() {
  const navigate = useNavigate();
  const [bannerData, setBannerData] = useState<PageSection | null>(null);

  useEffect(() => {
    fetchPageContent().then(content => {
      setBannerData(content.find(s => s.id === 'iphone-banner') ?? null);
    });
  }, []);

  const bannerTitle = bannerData?.title ?? 'iPhone 維修';
  const bannerSubtitle = bannerData?.subtitle ?? 'iPhone 6S 至 iPhone 16 系列全機型服務';
  const bannerImage = bannerData?.image ?? 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/iphonehero.jpg';

  const models = ['iPhone 17 系列', 'iPhone Air', 'iPhone 16 系列', 'iPhone 15 系列', 'iPhone 14 系列', 'iPhone 13 系列', 'iPhone 12 系列', 'iPhone 11 系列', 'iPhone SE', 'iPhone XS/XR', 'iPhone X 以下'];

  const faqs = [
    { q: '維修前需要先預約嗎？', a: '不需要，歡迎直接帶機到店，現場診斷免費。若零件需要訂購，會提前告知等候時間。' },
    { q: '維修後資料會不見嗎？', a: '一般維修（螢幕、電池、鏡頭）不影響資料。主板維修前建議先備份，我們也會協助確認。' },
    { q: '換完螢幕還有原廠功能嗎？', a: '使用原廠規格面板可維持觸控、亮度自動調節等功能。使用副廠屏會顯示非原廠提示，功能多數正常。' },
    { q: '保固期間壞了怎麼辦？', a: '保固期內因維修部位本身問題，免費重修。人為損壞、進水、二次摔落不在保固範圍。' },
  ];

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="pt-32 pb-16 bg-gray-950 relative overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <img src={bannerImage} alt="" className="w-full h-full object-cover object-top" />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="flex items-center gap-3 mb-6">
              <button onClick={() => navigate('/services')} className="text-gray-500 hover:text-orange-400 text-sm cursor-pointer">維修項目</button>
              <i className="ri-arrow-right-s-line text-gray-600" />
              <span className="text-orange-400 text-sm">iPhone 維修</span>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/20 border border-orange-500/30 rounded-2xl">
                <i className="ri-smartphone-line text-orange-400 text-3xl" />
              </div>
              <div>
                <h1 className="text-4xl font-bold text-white">{bannerTitle}</h1>
                <p className="text-gray-400 mt-1">{bannerSubtitle}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Repair Tabs + Sidebar */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-xl font-bold text-gray-900 mb-6">選擇維修項目</h2>
                <RepairTabs
                  tabs={TABS}
                  note="以上報價依機型與損壞程度而定。維修前提供精確報價，確認後再施工，絕無隱藏費用。"
                />
              </div>

              {/* Sidebar */}
              <div className="space-y-5">
                <div className="bg-gray-950 rounded-2xl p-6 text-white">
                  <h3 className="font-bold mb-1 text-sm text-orange-400 uppercase tracking-wide">支援機型</h3>
                  <p className="text-gray-400 text-xs mb-4">以下所有系列均支援</p>
                  <ul className="space-y-2">
                    {models.map(m => (
                      <li key={m} className="flex items-center gap-2 text-sm text-gray-300">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-orange-400 text-xs" />
                        </div>
                        {m}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-orange-50 border border-orange-100 rounded-2xl p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-xl">
                      <i className="ri-shield-check-line text-white text-sm" />
                    </div>
                    <span className="font-bold text-gray-900 text-sm">3 個月保固</span>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed">所有維修項目提供 3 個月保固，因維修部件本身問題免費重修。</p>
                </div>
                <div className="bg-gray-950 rounded-2xl p-5 text-center">
                  <div className="text-white text-sm font-semibold mb-1">免費到店診斷</div>
                  <div className="text-gray-400 text-xs mb-4">診斷清楚再報價，確認才施工</div>
                  <button onClick={() => navigate('/contact')} className="w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-xl cursor-pointer whitespace-nowrap transition-colors text-sm">立即預約</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">常見問題</h2>
            <div className="space-y-4">
              {faqs.map((f, i) => (
                <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0 mt-0.5">
                      <span className="text-orange-500 text-xs font-bold">Q</span>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 text-sm mb-2">{f.q}</div>
                      <div className="text-gray-500 text-sm leading-relaxed">{f.a}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 bg-gray-950">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h2 className="text-2xl font-bold text-white mb-3">iPhone 壞了？馬上處理</h2>
            <p className="text-gray-400 text-sm mb-7">免費診斷・透明報價・當日完工・3 個月保固</p>
            <div className="flex flex-wrap justify-center gap-4">
              <button onClick={() => navigate('/pricing')} className="px-8 py-3.5 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full cursor-pointer whitespace-nowrap transition-colors">查詢維修報價</button>
              <button onClick={() => navigate('/contact')} className="px-8 py-3.5 border border-white/30 text-white hover:bg-white/10 font-semibold rounded-full cursor-pointer whitespace-nowrap transition-colors">立即聯絡</button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
